<template>
  <div class="third PresetPersonalService">
    <div class="third-rea">
      <el-tabs v-model="roleType" @tab-click="change_FN">
        <el-tab-pane label="教工" name="TEACHER"></el-tab-pane>
        <el-tab-pane label="学生" name="STUDENT"></el-tab-pane>
        <el-tab-pane label="其他用户" name="OTHER"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="third-one">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-search"
            @click="hignSearch"
          >数据筛选</el-button>
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-refresh-left"
            @click="Reset"
          >重置</el-button>
        </div>
      </div>

      <template>
        <el-table
          class="PresetPersonalService-tableThree"
          :data="tableData"
          border
          stripe
          ref="otherTableBasic"
          row-key="otherUserId"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="32px" :reserve-selection="true"></el-table-column>
          <template v-for="(val, key) in tableDataShow">
            <el-table-column
              v-if="val.needKeyValue"
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              style="color:red"
              :show-overflow-tooltip="true"
            >
              <!-- <template slot-scope="scope">
                <el-button @click="clickFN" type="text" size="small">{{ scope.row[val.key] }}</el-button>
              </template>-->
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </template>

          <el-table-column label="操作" width="150px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="PersonalPresetService(scope.row)">管理预置服务</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="third-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </template>
    </div>
    <hign-modal
      modalTitle="数据筛选"
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
      ref="hignModal"
    ></hign-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
import { personalPresetTotalList } from "@/store/mymethod/PresetPersonalService"; //我的
// import { eduotheruserinfoRemovePort } from "@/api/c1.2/other.js";
export default {
  name: "PresetPersonalService",
  data() {
    return {
      loading: false,
      checkID: "",
      isIndeterminate: true,
      outputModal: false, // 导出弹窗
      isJS: true, //是否有检索条件
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      ruleFormOutPut: {
        checkAll: false, // 全选
        jbDesc: "学生基础数据201908021223",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      detailModal: false, // 详情弹窗
      isError: true, // 是否是错误提示
      noticeSpec: "", // 标红提示
      ruleFormImport: {
        jbDesc: "",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      importModal: false, // 导入弹窗
      fieldsModal: false, // 字段显示弹窗
      currentPage4: 1,
      searchForm: {
        content: "", // 内容
        word: "", // 敏感词
        type: "", // 类型
        nickname: "", // 昵称
        acount: "", // 账号
        campus: "", // 所属校区
        pubtime: "", // 发布时间
        status: "" //状态
      },
      checked: true,
      noticeModal: false, // 提示弹窗
      noticeType: 1, // 提示类型
      noitceContent: "是否确认删除？", // 提示信息
      noticeTitle: "确认操作", // 提示
      deleteRow: {}, // 单个删除行
      deleteList: [], // 多行删除
      keyIdList: [],
      type: "single",
      orderConfig: "", // 顺序设置
      tableDataShow: [], // 表格行设置
      //-----------------------------------------------
      tableRow: [
        {
          column: "工号",
          key: "account",
          needKeyValue: true,
          caseKey: "relate_id"
        },
        {
          column: "姓名",
          key: "userName",
          needKeyValue: false,
          caseKey: "real_name"
        },
        {
          column: "预置服务（个）",
          key: "count",
          needKeyValue: false,
          caseKey: "count"
        },
        {
          column: "最近预置时间",
          key: "newTime",
          needKeyValue: false,
          caseKey: "new_time"
        }
      ],
      roleType: "TEACHER",
      user_data: "", //用户信息
      pageIndex: 1, // 当前页  【必填】
      pageSize: 40, // 每页数量  【必填】
      total: 0, //数据总条数
      tableData: [], //表格数据
      //-------
      hignModal: false, // 高级搜索
      hignSearchRes: "", // 高级检索条件
      changeTab: false // 切换标签
    };
  },
  created() {
    this.user_data = JSON.parse(sessionStorage.getItem("user_data")); //用户登录信息
    // console.log("this.form", this.user_data);
    const dispField = this.getSessonValue("PresetPersonalServiceChange");
    const tableRow = this.getSessonValue("PresetPersonalService");
    // console.log(dispField);
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      // console.log(tableRow);
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
  },
  mounted() {
    const typeName = getStore({name: 'PresetPersonalService_tab'})
    if (typeName) {
      this.roleType = typeName
    }
    this.selectList();
  },
  computed: {
    // ...mapState({
    //   tableRow: state => state.power.selectConfig.eduOtherUserInfo,
    //   userInfo: state => state.user.userInfo
    // })
  },
  methods: {
    //change_FN标签点击
    change_FN(val) {
      const typeName = getStore({name: 'PresetPersonalService_tab'})
      this.$nextTick( ()=> {
        if (typeName !== this.roleType) {
          this.changeTab = true
        }
      })
      // console.log(typeName === val.name)
      this.pageIndex = 1
      this.hignSearchRes = "";
      console.log("val", val.name);
      this.roleType = val.name;
      const [account] = this.tableRow;
      switch (val.name) {
        case 'TEACHER':
          account.column = '工号';
          break;
        case 'STUDENT':
          account.column = '学号';
          break;
        case 'OTHER':
          account.column = '登录账号';
          break;
      
        default:
          break;
      }
      setStore({
        name: 'PresetPersonalService_tab',
        content: this.roleType,
        type: 'session'
      })
      this.selectList();
    },
    //获取列表
    selectList() {
      try {
        const params = [
          {
            current: this.pageIndex, // 当前页
            size: this.pageSize // 每页数量
          },
          {
            roleType: this.roleType, // 学生：STUDENT 老师：TEACHER  其他：OTHER  【必填】
            advancedSearch: this.hignSearchRes, // 高级检索
            dataSortStr: "" // 排序
          }
        ];
        this.loading = true
        personalPresetTotalList(params).then(res => {
          this.loading = false
          console.log("res", res);
          const data = res.data;
          if (data.status === 1000) {
            this.total = data.result.total;
            this.tableData = data.result.records;
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        this.loading = false
        console.log(err);
      }
    },
    // PersonalPresetService
    PersonalPresetService(row) {
      console.log("row", row);
      this.$emit("PersonalPresetService", row);
    },
    //条数变化
    handleSizeChange(val) {
      this.pageIndex = 1
      this.pageSize = val;
      this.selectList();
    },
    //页码变化
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.selectList();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
      if (this.changeTab) {
        this.$nextTick(()=> {
          this.$refs.hignModal.resetHSearch()
          this.changeTab = false
        })
      }
    },
    // 高级检索
    toHignSearch(res) {
      console.log("--------------------", res);
      this.hignSearchRes = res;
      this.pageIndex = 1;
      this.hignModal = false;
      this.selectList();
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    //重置
    Reset() {
      this.pageSize=40;
       this.pageIndex =1;
      // this.roleType = "STUDENT";
      this.hignSearchRes = "";
      this.selectList();
    },

    //------------------------------------------------------------------------
    // 高级检索
    // toHignSearch(res) {
    //     this.hignSearchRes = res;
    //     this.hignModal = false;
    //     this.$refs.otherTable.search({
    //         pageIndex: 1,
    //         params: {
    //             advancedSearch: this.hignSearchRes,
    //             tenantId: this.userInfo.tenant_id
    //         }
    //     });
    // },
    // add() {
    //     this.$emit("changeComponent", "DetailsInfo");
    // },
    handleSelectionChange(val) {
      this.deleteList = val.map(item => {
        return item.otherUserId;
      });
      this.keyIdList = val.map(item => {
        return item.keyId;
      });
      this.checkID = this.deleteList.join(",");
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
    getDataOrder(value) {
      this.orderConfig = value;
      this.search();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 单个删除
    deleteSingleRow(row) {
      this.typ = "single";
      this.deleteRow = row;
      this.noticeModal = true;
    },
    // 多个删除
    deleteMultileRow() {
      if (!this.deleteList.length) {
        return this.$message.warning("请勾选需要删除的用户");
      }
      this.type = "multi";
      this.noticeModal = true;
    },
    async eduotheruserinfoRemove(params) {
      this.noticeModal = false;
      const {
        data: { msg, status }
      } = await eduotheruserinfoRemovePort(params);
      if (status === 1000) {
        this.$message.success("删除成功");
        this.$refs.otherTableBasic.clearSelection();
        if (this.typ === "single") {
          this.deleteRow = null;
        } else {
          this.deleteList = [];
          this.keyIdList = [];
        }
        return this.search();
      }
      this.$message.error(msg);
      return {};
    },
    cancel() {
      if (this.type === "single") {
        this.deleteRow = null;
      }
      this.noticeModal = false;
    },
    confirm() {
      if (this.type === "single") {
        console.log(this.deleteRow);
        return this.eduotheruserinfoRemove({
          ids: this.deleteRow.otherUserId,
          keyIds: this.deleteRow.keyId,
          tenantId: this.userInfo.tenant_id
        });
      }
      console.log("当前删除列表", this.deleteList);
      return this.eduotheruserinfoRemove({
        ids: this.deleteList.join(","),
        keyId: this.keyIdList.join(","),
        tenantId: this.userInfo.tenant_id
      });
    },
    reset() {
      Object.assign(this.searchForm, this.$options.data().searchForm);
      this.search();
    },
    search() {
      const params = cloneDeep(this.searchForm);
      params.dataSortStr = this.orderConfig;
      this.$refs.otherTable.search({
        pageIndex: 1,
        params
      });
    },
    changeComponent(rowData) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session"
      });
      this.$emit("changeComponent", "DetailsInfo");
    },
    // 导出数据
    outputData() {
      this.outputModal = true;
    },
    // 关闭导出
    closeOutPut() {
      this.outputModal = false;
    },
    // 关闭详情
    closeDetail() {
      this.detailModal = false;
    },
    // 确认弹窗
    agreeNotice() {
      this.noticeModal = false;
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 删除
    deleteItem() {
      this.noticeModal = true;
    },
    // 字段显示
    showFields() {
      this.fieldsModal = true;
      this.$nextTick(() => {
        this.initSortabel();
      });
    },
    // 保存字段
    addFields() {
      console.log(111);
    },
    // 关闭字段显示弹窗
    closeFileds() {
      this.fieldsModal = false;
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    }
  }
};
</script>
<style lang="scss">
.PresetPersonalService {
  .PresetPersonalService-tableThree {
    .el-table__body-wrapper {
      height: calc(100vh - 170px);
      overflow-y: auto;
    }
  }
}
</style>
